import { useState, useEffect, createContext, useContext } from "react";
import { v4 as uuidv4 } from "uuid";

const AuthContext = createContext();
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const stored = localStorage.getItem("attendanceUser");
    if (stored) setUser(JSON.parse(stored));
  }, []);
  const register = async ({ username, role }) => {
    const deviceId = uuidv4();
        // 1) call your Vercel endpoint
    const res = await fetch(
      "https://online-attendance-server.vercel.app/api/register.js",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, role, deviceId }),
      }
    );
    const json = await res.json();
    if (!res.ok) {
      // bubble up the error
      console.log(json.error);
      
      throw new Error(json.error || "Registration failed");
    }

    // 2) only after success, persist locally
    const u = { username, role, deviceId };
    localStorage.setItem("attendanceUser", JSON.stringify(u));
    setUser(u);
    return u;
  };
  const logout = () => {
    localStorage.removeItem("attendanceUser");
    setUser(null);
  };

    const login = (u) => {
    localStorage.setItem("attendanceUser", JSON.stringify(u));
    setUser(u);
  };
  return (
    <AuthContext.Provider value={{ user, register, logout ,login}}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => useContext(AuthContext);
